import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class NavDataTask extends AbstractRequestTask {
  
  getParams() {
    const params = super.getParams();
    delete params.user_token;
    return params;
  }

  getUrl() {
    const http = "https://";
    const url = Launcher.get("akamai_mfwk");
    // return `${http}${url}/services/nav/data`;
   // const url = "mfwkngv-api-test.clarovideo.net";
    return `${http}${url}/services/nav/data`;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default NavDataTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/application/NavDataTask.js